import { Action, ThunkDispatch, configureStore } from "@reduxjs/toolkit";
import tenantReducer from "../reducers/tenant";
import businessReducer from "../reducers/business";
import settingsReducer from "../reducers/settings";
import versionReducer from "../reducers/versions";
import loginReducer from "../reducers/login";
import cartReducer from "../reducers/cart";
import cartsReducer from "../reducers/carts";
import itemReducer from "../reducers/item";
import appReducer from "../reducers/app";
import tradersReducer from "../reducers/traders";
import traderReducer from "../reducers/trader";
import cartdefaultReducer from "../reducers/cartDefault";
import savedcartReducer from "../reducers/savedcart";
import statusReducer from "../reducers/status";
import addresspriceruleReducer from "../reducers/addressPriceRule";
import itemFilterReducer from "../reducers/itemFilter";
import itemSOFilterReducer from "../reducers/itemSOFilter";
import translationsReducer from "../reducers/translations";
import futureOrderReducer from "../reducers/futureOrder";
import ipReducer from "../reducers/ip";
import addressReducer from "../reducers/address";
import itemDetailReducer from "../reducers/itemDetail";
import invitationReducer from "../reducers/invitation";
import standingOrdersReducer from "../reducers/standingOrder";
import standingOrderItemsReducer from "../reducers/standingOrderItems";
import localNowReducer from "../reducers/localNow";
import standingOrderSummaryReducer from "../reducers/standingOrderSummary";

import { loadState } from "../browser-storage";
import { useDispatch } from "react-redux";

const store = configureStore({
  reducer: {
    status: statusReducer,
    version: versionReducer,
    tenant: tenantReducer,
    business: businessReducer,
    settings: settingsReducer,
    login: loginReducer,
    app: appReducer,
    traders: tradersReducer,
    trader: traderReducer,
    cartdefault: cartdefaultReducer,
    cart: cartReducer,
    carts: cartsReducer,
    item: itemReducer,
    savedcart: savedcartReducer,
    addresspricerule: addresspriceruleReducer,
    itemFilter: itemFilterReducer,
    translations: translationsReducer,
    futureorder: futureOrderReducer,
    ip: ipReducer,
    address: addressReducer,
    itemDetail: itemDetailReducer,
    invitation: invitationReducer,

    standingOrder: standingOrdersReducer,
    standingOrderItems: standingOrderItemsReducer,
    itemSOFilter: itemSOFilterReducer,
    standingOrderSummary: standingOrderSummaryReducer,
    localNow: localNowReducer,
  },

  preloadedState: loadState(),

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export type ThunkAppDispatch = ThunkDispatch<RootState, void, Action>;
export const useAppThunkDispatch = () => useDispatch<ThunkAppDispatch>();

export default store;
